<template>
    <v-container
        fluid
        class="qa-form" pt-3>
        <v-btn @click="goToAttestationList" class="mb-4">
          <v-icon
            color="primary"
            class="mr-2">arrow_back</v-icon> Go back
        </v-btn>
        <material-card color="orange" title="Attestation">
          <v-layout>
              <v-flex>
              <p>Instructions: All fields with <span class="required">*</span> are required to proceed with submission. <span v-if="formStep == 1">Please review and confirm the value of each field in Step 1 by clicking the check button next to each one before proceeding to the next step.</span></p>
              </v-flex>
          </v-layout>
          <v-stepper v-model="formStep">
            <v-stepper-header>
              <v-stepper-step
                :complete="formStep > 1"
                step="1"
                :editable="false"
              >
                Step 1
              </v-stepper-step>
              <v-divider />
              <v-stepper-step
                :complete="formStep > 2"
                step="2"
              >
                Step 2
              </v-stepper-step>
              <v-divider />

                <v-stepper-step
                  :complete="formStep > 3"
                  step="3"
                >
                  Step 3
                </v-stepper-step>
                <v-divider />
                <v-stepper-step
                  :complete="formStep > 4"
                  step="4"
                >
                  Step 4
                </v-stepper-step>
                <v-divider />
                <v-stepper-step
                  :complete="formStep > 5"
                  step="5">
                  Step 5
                </v-stepper-step>
                <v-divider />
                <v-stepper-step 
                  :complete="formStep > 6"
                  step="6">
                  Final Step
                </v-stepper-step>
              
                <!-- <v-stepper-step
                  v-if="request.Internal_Vs_Saas == 'SaaS'"
                  :complete="formStep > 3"
                  step="3"
                >
                  Step 3
                </v-stepper-step>
                <v-divider v-if="request.Internal_Vs_Saas == 'SaaS'"/>
                <v-stepper-step
                  v-if="request.Internal_Vs_Saas == 'SaaS'"
                  :complete="formStep > 4"
                  step="4"
                >
                  Step 4
                </v-stepper-step>
                <v-divider v-if="request.Internal_Vs_Saas == 'SaaS'"/>
                <v-stepper-step
                  v-if="request.Internal_Vs_Saas == 'SaaS'"
                  :complete="formStep > 5"
                  step="5">
                  Step 5
                </v-stepper-step>
                <v-divider v-if="request.Internal_Vs_Saas == 'SaaS'"/>
              <v-stepper-step 
                :complete="formStep > 6"
                step="6">
                Final Step
              </v-stepper-step> -->
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-layout align-center mb-4>
                    <v-flex md5>
                    <label>Account ID: <span class="required">*</span></label>
                    </v-flex>
                    <v-flex md9>
                      <v-combobox
                        success
                        readonly
                        v-if="isBulkRequest"
                        v-model="request.Acct_ID"
                        multiple
                        small-chips
                        flat
                        hide-details
                        filled
                        dense
                        :counter="true"
                      />                    
                      <v-text-field
                        v-else
                        readonly
                        v-model="request.Acct_ID"
                      />
                    </v-flex>
                </v-layout>
                <v-layout align-center mb-4>
                    <v-flex md5>
                    <label>Account Owner: <span class="required">*</span></label>
                    </v-flex>
                    <v-flex md9>
                    <v-text-field
                      ref="Acct_Owner"
                      
                      
                      v-validate="'required|email'"
                      data-vv-name="AccountOwner"
                      data-vv-validate-on="blur"
                      :error-messages="errors.collect('AccountOwner')"
                      v-model.trim="request.Acct_Owner"
                      placeholder="Enter a value"
                      name="Account_Owner"
                      @click="onEditField('Acct_Owner')"
                    >
                      <template v-slot:append-outer>
                        <v-btn
                          :class="`my-0 ${validatedFields.Acct_Owner ? 'success' : ''}`"
                          small
                          @click="onValueConfirm('Acct_Owner')"
                          title="Confirm"
                        >
                          <v-icon small>check</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout align-center mb-4>
                    <v-flex md5>
                    <label>Financial Owner: <span class="required">*</span></label>
                    </v-flex>
                    <v-flex md9>
                    <v-text-field
                      ref="Financial_Owner"
                      v-validate="'required'"
                      data-vv-name="FinancialOwner"
                      data-vv-validate-on="blur"
                      :error-messages="errors.collect('FinancialOwner')"
                      v-model.trim="request.Financial_Owner"
                      placeholder="Enter a value"
                      name="Financial_Owner"
                      @click="onEditField('Financial_Owner')"
                    >
                      <template v-slot:append-outer>
                        <v-btn
                          :class="`my-0 ${validatedFields.Financial_Owner ? 'success' : ''}`"
                          small
                          @click="onValueConfirm('Financial_Owner')"
                          title="Confirm"
                        >
                          <v-icon small>check</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout align-center mb-4>
                    <v-flex md5>
                    <label>WBS Code: <span class="required">*</span></label>
                    </v-flex>
                    <v-flex md9>
                    <v-text-field
                      ref="WBS_Code"
                      v-validate="'required'"
                      data-vv-name="WBSCode"
                      data-vv-validate-on="blur"
                      :error-messages="errors.collect('WBSCode')"
                      v-model="request.WBS_Code"
                      placeholder="Enter a value"
                      name="WBS_Code"
                      @click="onEditField('WBS_Code')"
                    >
                      <template v-slot:append-outer>
                        <v-btn
                          :class="`my-0 ${validatedFields.WBS_Code ? 'success' : ''}`"
                          small
                          @click="onValueConfirm('WBS_Code')"
                        >
                          <v-icon small>check</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout align-center mb-4>
                    <v-flex md5>
                    <label>Customer Name: <span class="required">*</span></label>
                    </v-flex>
                    <v-flex md9>
                    <v-text-field
                      ref="Customer_Name"
                      v-validate="'required'"
                      data-vv-name="CustomerName"
                      data-vv-validate-on="blur"
                      :error-messages="errors.collect('CustomerName')"
                      v-model="request.Customer_Name"
                      placeholder="Enter a value"
                      name="Customer_Name"
                      @click="onEditField('Customer_Name')"
                    >
                      <template v-slot:append-outer>
                        <v-btn
                          :class="`my-0 ${validatedFields.Customer_Name ? 'success' : ''}`"
                          small
                          @click="onValueConfirm('Customer_Name')"
                          title="Confirm"
                        >
                          <v-icon small>check</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout align-center mb-4>
                    <v-flex md5>
                    <label>Managed Services: <span class="required">*</span></label>
                    </v-flex>
                    <v-flex md9>
                        <v-select
                          ref="Managed_Services"
                          v-validate="'required'"
                          data-vv-name="ManagedServices"
                          data-vv-validate-on="blur"
                          :error-messages="errors.collect('ManagedServices')"
                          v-model="request.Managed_Services"
                          :items="awsManagedServices"
                          :menu-props="{ maxHeight: '400' }"
                          placeholder="Select a value"
                          @click="onEditField('Managed_Services')"
                        >
                          <template v-slot:append-outer>
                            <v-btn
                              :class="`my-0 ${validatedFields.Managed_Services ? 'success' : ''}`"
                              small
                              @click="onValueConfirm('Managed_Services')"
                              title="Confirm"
                            >
                              <v-icon small>check</v-icon>
                            </v-btn>
                          </template>
                        </v-select>
                    </v-flex>
                </v-layout>
                <v-layout align-center mb-4>
                    <v-flex md5>
                    <label>Account Purpose: <span class="required">*</span></label>
                    </v-flex>
                    <v-flex md9>
                        <v-select
                          ref="Acct_Purpose"
                          v-validate="'required'"
                          data-vv-name="AcctPurpose"
                          data-vv-validate-on="blur"
                          :error-messages="errors.collect('AcctPurpose')"
                          v-model="request.Acct_Purpose"
                          :items="acctPurpose"
                          :menu-props="{ maxHeight: '400' }"
                          placeholder="Select a value"
                          @click="onEditField('Acct_Purpose')"
                        >
                          <template v-slot:append-outer>
                            <v-btn
                              :class="`my-0 ${validatedFields.Acct_Purpose ? 'success' : ''}`"
                              small
                              @click="onValueConfirm('Acct_Purpose')"
                              title="Confirm"
                            >
                              <v-icon small>check</v-icon>
                            </v-btn>
                          </template>
                        </v-select>
                    </v-flex>
                </v-layout>

                <!-- <v-layout align-center mb-4>
                    <v-flex md5>
                    <label>AWS Support Type: <span class="required">*</span></label>
                    </v-flex>
                    <v-flex md9>
                        <v-select
                          ref="AWS_Support_Type"
                          :solo="editing['AWS_Support_Type']"
                          :readonly="!editing['AWS_Support_Type']"
                          v-validate="'required'"
                          data-vv-name="AWSSupportType"
                          data-vv-validate-on="blur"
                          :error-messages="errors.collect('AWSSupportType')"
                          v-model="request.AWS_Support_Type"
                          :items="awsSupportTypes"
                          :menu-props="{ maxHeight: '400' }"
                          placeholder="Select a value"
                          attach
                        >
                          <template v-slot:append-outer>
                            <v-btn
                              class="my-0"
                              small
                              @click="onEditField('AWS_Support_Type')"
                              title="Edit"
                            >
                              <v-icon small>edit</v-icon>
                            </v-btn>
                            <v-btn
                              :class="`my-0 ${validatedFields.AWS_Support_Type ? 'success' : ''}`"
                              small
                              @click="onValueConfirm('AWS_Support_Type')"
                              title="Confirm"
                            >
                              <v-icon small>check</v-icon>
                            </v-btn>
                          </template>
                          
                        </v-select>
                    </v-flex>
                </v-layout> -->

                <!-- <v-layout align-center mb-4>
                    <v-flex md5>
                    <label>Opportunity ID: <span class="required">*</span></label>
                    </v-flex>
                    <v-flex md9>
                    <v-text-field
                      ref="Opportunity_Id"
                      :solo="editing['Opportunity_Id']"
                      :readonly="!editing['Opportunity_Id']"
                      v-validate="'required'"
                      data-vv-name="OpportunityID"
                      data-vv-validate-on="blur"
                      :error-messages="errors.collect('OpportunityID')"
                      v-model="request.Opportunity_Id"
                      placeholder="Enter a value"
                      name="Opportunity_Id"
                    >
                      <template v-slot:append-outer>
                        <v-btn
                          class="my-0"
                          small
                          @click="onEditField('Opportunity_Id')"
                          title="Edit"
                        >
                          <v-icon small>edit</v-icon>
                        </v-btn>
                        <v-btn
                          :class="`my-0 ${validatedFields.Opportunity_Id ? 'success' : ''}`"
                          small
                          @click="onValueConfirm('Opportunity_Id')"
                          title="Confirm"
                        >
                          <v-icon small>check</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                    </v-flex>
                </v-layout> -->
                <v-layout class="mt-5">
                  <div>
                    <v-btn
                      :disabled="disableNextStepButton(1)"
                      color="success"
                      @click="formStep = 2"
                    >
                      Next
                    </v-btn>
                    <small>&nbsp;{{noOfValidated}} out of 6 confirmed values</small>
                  </div>

                </v-layout>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-layout row wrap align-center mb-4>
                  <h3 class="font-weight-bold">Attestation Purpose</h3>
                  <p>The purpose of this attestation is to reaffirm and review the intended purpose and usage of the AWS account(s) under your ownership. This review is conducted to ensure that the utilization of said account(s) remains within the boundaries set forth by the DXC/AWS contractual agreements.</p>
                  <v-flex sm12>
                    <v-checkbox
                      v-model="confirmAttestation"
                      value="true"
                      color="orange"
                    >
                      <span slot="label"  style="font-size: 20px;" class="black--text font-weight-bold">Confirm</span>
                    </v-checkbox>
                  </v-flex>
                  <p><i>
                    Your responses should apply to all the workloads under this account.If your workloads are variable, contact AWS-Account-OnBoarding@dxc.com
                  </i></p>
                  <!-- <v-flex sm12>  
                  <label>Internal vs SaaS <span class="required">*</span></label>
                  </v-flex>
                  <v-flex sm12>
                      <v-layout 
                          column
                          align-start>
                          <v-flex>
                          <v-radio-group v-model="request.Internal_Vs_Saas">
                              <v-radio
                                  color="primary"
                                  value="Internal"
                                  
                              >
                                  <span slot="label" class="ml-2 black--text radioLabel">Is the AWS cloud environment used for DXC internal use only, such as hosting an internal DXC application or internal training account to which DXC clients do not have access?</span>
                              </v-radio>
                              <v-radio
                                  color="primary"
                                  value="SaaS"
                              >
                              <span slot="label" class="ml-2 black--text radioLabel">Is this account used for delivering a one or more differentiated solutions to the client which is built by DXC for the client?</span>
                              </v-radio>
                          </v-radio-group>
                          </v-flex>
                      </v-layout>
                  </v-flex> -->
                </v-layout>

                <v-btn 
                  @click="formStep = 1"
                  text>
                  Prev
                </v-btn>
                <v-btn
                  :disabled="!confirmAttestation"
                  color="success"
                  @click="formStep = 3"
                >
                  Next
                </v-btn>
                <!-- <v-btn
                  :disabled="!confirmAttestation"
                  color="success"
                  @click="validateStep(2)"
                >
                  Next
                </v-btn>    -->
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-layout align-center row wrap>
                    <v-flex sm12>
                    <h3 class="font-weight-bold mb-0">Account Type <span class="required">*</span></h3>
                    <small>Select one of the options below</small>
                    </v-flex>
                    <v-flex sm12>
                        <v-layout 
                            column
                            align-start>
                            <v-flex>
                            <v-radio-group v-model="request.Acct_Type" >
                                <v-radio
                                    color="primary"
                                    value="Internal"
                                    class="mb-4"
                                >
                                    <p slot="label" style="font-size: 20px !important" class="ml-2 mb-0 black--text radioLabel"><span class="font-weight-bold">Internal</span> - The AWS cloud environment is used for DXC internal use only, such as hosting an internal DXC application or internal training account, where <span class="font-weight-bold">no party outside DXC has access to the AWS environment.</span></p>
                                </v-radio>
                                <v-radio
                                    color="primary"
                                    value="Commercial"
                                    class="mb-4"
                                >
                                <p slot="label" style="font-size: 20px !important" class="ml-2 mb-0 black--text radioLabel"><span class="font-weight-bold">Commercial</span> - The AWS cloud environment is used to provide services to the customers or partners outside of DXC.</p>
                                </v-radio>
                            </v-radio-group>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                        
                <v-btn 
                  text
                  @click="formStep = 2">
                  Prev
                </v-btn>
                <v-btn
                  :disabled="!request.Acct_Type"
                  color="success"
                  @click="formStep = 4"
                >
                  Next
                </v-btn>
              </v-stepper-content>
              <v-stepper-content step="4">
                
                <v-layout align-center row wrap>
                    <v-flex sm12>
                    <h3 class="font-weight-bold mb-0">Provided Commercial Service <span class="required">*</span></h3>
                    <small>Select one of the options below</small>
                    </v-flex>
                    <v-flex sm12>
                        <v-layout 
                            column
                            align-start>
                            <v-flex>
                            <v-radio-group v-model="request.Provided_Commercial_Service" >
                                <v-radio
                                    color="primary"
                                    value="SaaS"
                                    class="mb-4"
                                >
                                    <p slot="label" style="font-size: 20px !important" class="ml-2 mb-0 black--text radioLabel"><span class="font-weight-bold">SaaS (Software as a Service)</span> - Software Services provided by DXC are charged to customers based on units of measure; such as the number of users , subscriptions, amount of data processing etc.</p>
                                </v-radio>
                                <v-radio
                                    color="primary"
                                    value="Differentiated Solution"
                                    class="mb-4"
                                >
                                <p slot="label" style="font-size: 20px !important" class="ml-2 mb-0 black--text radioLabel"><span class="font-weight-bold">Differentiated Solution</span> - The AWS cloud environment is used to provide services to the customers or partners outside of DXC.</p>
                                </v-radio>
                                <v-radio
                                    color="primary"
                                    value="None of the above"
                                    class="mb-4"
                                >
                                    <p slot="label" style="font-size: 20px !important" class="ml-2 mb-0 black--text radioLabel"><span class="font-weight-bold">None of the above</span> - DXC hosts the client&apos;s AWS environment with any level of DXC provided managed services.  The Customer&apos;s AWS Account is under a DXC owned master payer.</p>
                                </v-radio>
                            </v-radio-group>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>

                <v-btn 
                  text
                  @click="formStep = 3">
                  Prev
                </v-btn>
                <v-btn
                  :disabled="!request.Provided_Commercial_Service"
                  color="success"
                  @click="formStep = 5"
                >
                  Next
                </v-btn>
              </v-stepper-content>

              <v-stepper-content step="5">
                <v-layout align-center row wrap>
                    <v-flex sm12>
                    <h3 class="font-weight-bold mb-0">Customer Console Access <span class="required">*</span></h3>
                    <small>Select one of the options below</small>
                    </v-flex>
                    <v-flex sm12>
                        <v-layout 
                            column
                            align-start>
                            <v-flex>
                            <v-radio-group v-model="request.Customer_Console_Access" >
                                <v-radio
                                    color="primary"
                                    value="No Access"
                                    class="mb-4"
                                >
                                    <p slot="label" style="font-size: 20px !important" class="ml-2 mb-0 black--text radioLabel"><span class="font-weight-bold">No Access</span> - Client does not have access to the AWS account (Application access is allowed)</p>
                                </v-radio>
                                <v-radio
                                    color="primary"
                                    value="Read Access"
                                    class="mb-4"
                                >
                                <p slot="label" style="font-size: 20px !important" class="ml-2 mb-0 black--text radioLabel"><span class="font-weight-bold">Read Only Access</span> - Client has access to AWS with Read Only permissions</p>
                                </v-radio>
                                <v-radio
                                    color="primary"
                                    value="Write Access"
                                    class="mb-4"
                                >
                                    <p slot="label" style="font-size: 20px !important" class="ml-2 mb-0 black--text radioLabel"><span class="font-weight-bold">Edit: Read & Write Access</span> - Client has elevated rights for editing the environment</p>
                                </v-radio>
                            </v-radio-group>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>

                <v-btn 
                  text
                  @click="formStep = 4">
                  Prev
                </v-btn>
                <v-btn
                  :disabled="!request.Customer_Console_Access"
                  color="success"
                  @click="formStep = 6"
                >
                  Next
                </v-btn>
              </v-stepper-content>

              <v-stepper-content step="6">
                <v-layout row wrap align-center mb-4>
                  <h3 class="font-weight-bold">Formal attestation</h3>
                  <p>- I hereby consent that all the information provided herein is true, accurate, and complete to the best of my knowledge. Furthermore, I authorize the use of this information for the purpose of the AWS audit. </p>
                  <v-flex sm12>
                    <v-checkbox
                      v-model="consentAttestation"
                      value="true"
                      color="orange"
                      label="Confirm"
                    >
                      <span slot="label" class="black--text" style="font-size: 20px;">Consent</span>
                    </v-checkbox>
                  </v-flex>
                </v-layout>
                <v-btn 
                  text
                  @click="formStep = 5 ">
                  Prev
                </v-btn>
                <v-btn
                  :disabled="incompleteInputs"
                  color="success"
                  @click="onSubmit" 
                  :loading="submitting"
                >
                  Submit
                </v-btn>
                </v-stepper-content>

              <!-- <v-stepper-content step="3">
                <v-layout
                  v-if="request.Internal_Vs_Saas && request.Internal_Vs_Saas != 'Internal'"
                  align-center mb-4 row wrap>
                    <v-flex sm12>
                    <label>Direct VS Indirect console access <span class="required">*</span></label>
                    </v-flex>
                    <v-flex sm12>
                        <v-layout 
                            column
                            align-start>
                            <v-flex>
                            <v-radio-group v-model="request.Direct_Vs_Indirect_Access" >
                                <v-radio
                                    color="primary"
                                    value="SPP"
                                >
                                    <span slot="label" class="ml-2 black--text radioLabel">In the differentiated solution(s), does the client have access to the AWS console or to the AWS services directly? (SPP)</span>
                                </v-radio>
                                <v-radio
                                    color="primary"
                                    value="PPA"
                                >
                                <span slot="label" class="ml-2 black--text radioLabel">Does the client consume the services using the application layers without access to the AWS console and services? (PPA)</span>
                                </v-radio>
                            </v-radio-group>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                        
                <v-btn 
                  text
                  @click="formStep = 2">
                  Prev
                </v-btn>
                <v-btn
                  :disabled="disableNextStepButton(3)"
                  color="success"
                  @click="formStep = 4"
                >
                  Next
                </v-btn>
              </v-stepper-content> -->

              <!-- <v-stepper-content step="4">
                
                <v-layout 
                  v-if="request.Internal_Vs_Saas && request.Internal_Vs_Saas != 'Internal'"
                  align-center mb-4 row wrap>
                    <v-flex sm12>
                        <label>Does the AWS account contain any new workloads that were added to the account since the original account creation/ migration? Note: a "new workload workload" means a new application or web site or expansion to a new business<span class="required">*</span></label>
                    </v-flex>
                    <v-flex sm12>
                        <v-layout 
                            column
                            align-start>
                            <v-flex>
                            <v-radio-group v-model="request.New_Workload">
                                <v-radio
                                    color="primary"
                                    value="Yes"
                                >
                                    <span slot="label" class="ml-2 black--text radioLabel">Yes</span>
                                </v-radio>
                                <v-radio
                                    color="primary"
                                    value="No"
                                >
                                <span slot="label" class="ml-2 black--text radioLabel">No</span>
                                </v-radio>
                            </v-radio-group>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex
                      v-if="request.Internal_Vs_Saas && request.Internal_Vs_Saas != 'Internal' && request.New_Workload == 'Yes'"
                      sm12
                      md6>
                      <v-layout align-center mb-4>
                          <v-flex md3>
                          <label>SFDC ID: <span class="required">*</span></label>
                          </v-flex>
                          <v-flex md9>
                          <v-text-field
                              hide-details
                              v-model="request.SFDC_ID"
                              placeholder="Enter a value"
                              name="SFDC_ID"
                              solo
                          />
                          </v-flex>
                      </v-layout>
                  </v-flex>
                </v-layout>

                <v-btn 
                  text
                  @click="formStep = 3">
                  Prev
                </v-btn>
                <v-btn
                  :disabled="disableNextStepButton(4)"
                  color="success"
                  @click="formStep = 5"
                >
                  Next
                </v-btn>
              </v-stepper-content> -->

              <!-- <v-stepper-content step="5">

                <v-layout
                  v-if="request.Internal_Vs_Saas && request.Internal_Vs_Saas != 'Internal'"
                  align-center mb-4 row wrap>
                    <v-flex sm12>
                        <label>What DXC services or solutions are being provided for the AWS account? Please describe or attach architecture diagram or SOW document</label>
                    </v-flex>
                    <v-flex sm12 mt-2>
                        <v-textarea
                        clearable
                        v-model="request.DXC_Services"
                        solo/>
                    </v-flex>
                </v-layout>
                <v-layout 
                  v-if="request.Internal_Vs_Saas && request.Internal_Vs_Saas != 'Internal'"
                  align-center mb-4 row wrap>
                    <v-flex sm12>
                        <label>Upload architecture diagram if available</label>
                    </v-flex>
                    <v-flex sm12>
                      <formMultipleUploads @setFiles="setFileData" :isMultiple="true"/>
                    </v-flex>
                    <v-flex sm12>
                      <div v-for="file in fileData.files">
                        <a href="javascript:void(0)">{{file.name}}</a>
                      </div>
                    </v-flex>
                </v-layout>

                <v-btn 
                  text
                  @click="formStep = 4">
                  Prev
                </v-btn>
                <v-btn
                  color="success"
                  @click="formStep = 6"
                >
                  Next
                </v-btn>
              </v-stepper-content> -->

              <!-- <v-stepper-content step="6">

                <v-layout align-center mb-4 row wrap>
                    <v-flex sm12>
                        <label>Confirm Correctness of your statement<span class="required">*</span></label>
                    </v-flex>
                    <v-flex sm12>
                        <v-layout 
                            column
                            align-start>
                            <v-flex>
                            <v-radio-group v-model="request.Confirm_Correctness" >
                                <v-radio
                                    color="primary"
                                    value="Yes"
                                >
                                    <span slot="label" class="ml-2 black--text radioLabel">Yes</span>
                                </v-radio>
                                <v-radio
                                    color="primary"
                                    value="No"
                                >
                                <span slot="label" class="ml-2 black--text radioLabel">No</span>
                                </v-radio>
                            </v-radio-group>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>

                <v-btn 
                  text
                  @click="formStep = request.Internal_Vs_Saas && request.Internal_Vs_Saas != 'Internal' ? 5 : 2">
                  Prev
                </v-btn>
                <v-btn
                  :disabled="incompleteInputs"
                  color="success"
                  @click="onSubmit" 
                  :loading="submitting"
                >
                  Submit
                </v-btn>
              </v-stepper-content> -->
            </v-stepper-items>
          </v-stepper>

          <!-- <v-layout row wrap>
              <v-flex
              md6>
              <v-text-field
                  v-model="requestorName"
                  label="Requestor Name"
                  solo
              />
              </v-flex>
              <v-flex
              md6>
              <v-text-field
                  v-model="requestorEmail"
                  label="Requestor Email"
                  solo
              />
              </v-flex>
          </v-layout>
          <v-layout justify-center>
              <v-btn class="success" :disabled="incompleteInputs" @click="onSubmit" :loading="submitting">SUBMIT</v-btn>
          </v-layout> -->
        </material-card>
    </v-container>
</template>
  
<script>
import {
  mapMutations,
  mapState,
  mapActions
} from 'vuex'

export default {
  data() {
    return {
      formStep: 0,
      requestorName: null,
      requestorEmail: null,
      awsSupportTypes: ['Enterprise', 'Developer', 'Business', 'Basic'],
      awsManagedServices: ['Internal', 'Silver non-managed', 'Silver CloudOps managed', 'Gold', 'Custom managed', 'No managed services', 'Amazon Managed Services (AMS)' ],
      // awsManagedServices: [ 'DXC Silver', 'DXC Gold', 'Amazon Managed Services', 'None (Customer Managed)'],
      acctPurpose:['PROD', 'STAGE', 'QA', 'DEV', 'TEST', 'POC', 'DEMO', 'SANDBOX', 'TRAINING', 'SERVICE ACCOUNT'],
      editing: {
        Acct_ID: false,
        Acct_Owner: false,
        Financial_Owner: false,
        WBS_Code: false,
        Customer_Name: false,
        Managed_Services: false,
        Acct_Purpose: false,
        // AWS_Support_Type: false,
        // Opportunity_Id: false
      },
      validatedFields: {
        Acct_ID: false,
        Acct_Owner: false,
        Financial_Owner: false,
        WBS_Code: false,
        Customer_Name: false,
        Managed_Services: false,
        Acct_Purpose: false,
        // AWS_Support_Type: false,
        // Opportunity_Id: false
      },
      noOfValidated: 0,
      allFieldsValid: false,
      confirmAttestation: false,
      consentAttestation: false
    }
  },
  mounted() {
    this.requestorName = this.$store.state.currentUser.name
    this.requestorEmail = this.$store.state.currentUser.email
    this.request.Requestor_Id = this.$store.state.currentUser.requestor_id
  },
  computed: {
    ...mapState('user/attestation', ['submitting','request', 'isBulkRequest', 'fileData', 'requestIsInternal', 'requestIsNewWorkload', 'fileData']),
    incompleteInputs() {

      if (!this.request.Acct_ID ||
          !this.request.Acct_Owner ||
          !this.request.Financial_Owner ||
          !this.request.WBS_Code ||
          !this.request.Customer_Name ||
          !this.request.Acct_Purpose ||
          !this.request.Managed_Services ||
          !this.request.Acct_Type ||
          !this.request.Provided_Commercial_Service ||
          !this.request.Customer_Console_Access) {
        return true
      }

      // if (this.request.Internal_Vs_Saas == 'Internal') {
      //   if ( !this.request.Confirm_Correctness) {
      //     return true
      //   }
      // } else if (this.request.Internal_Vs_Saas == 'SaaS') {

      //   if ( !this.request.Direct_Vs_Indirect_Access || !this.request.Confirm_Correctness ) {
      //     return true
      //   }

      //   if (!this.request.New_Workload || (this.request.New_Workload == 'Yes' && !this.request.SFDC_ID)) {
      //     return true
      //   }
      // }

      if(!this.confirmAttestation || !this.consentAttestation) return true

      // if (this.request.Confirm_Correctness == 'No') {
      //   return true
      // }

      if (this.errors.items.length > 0) {
        return true
      }

      // everything valid
      return false
    }
  },
  watch: {
    // Watch for changes on the 'user' object
    validatedFields: {
      handler(newVal, oldVal) {
        
        let noOfValidated = 0
        // check 
        for (const field in this.validatedFields) {
          if (Object.prototype.hasOwnProperty.call(this.validatedFields, field)) {
            if (this.validatedFields[field] === true ) {
              noOfValidated++
            }
          }
        }
        this.allFieldsValid = noOfValidated == 6 ? true : false
        this.noOfValidated = noOfValidated
      },
      deep: true // To watch for changes on nested properties of the object
    }
  },
  methods: {
    ...mapActions({
      attestationSubmit: 'user/attestation/submitAttestation'
    }),

    setFileData(data) {
      console.log('setting file data')
      console.log(data)
      this.$store.commit('user/attestation/setFileData', data)
    },
    onSubmit() {
      let attestationData = {
        ...this.request,
        ...this.fileData
      }

      this.attestationSubmit(attestationData)
    },
    goToAttestationList() {
      this.$router.go(-1)
      this.$store.commit('user/attestation/clearRequest')
    },
    disableNextStepButton(step) {
      switch (step) {
        case 1:
          return !this.request.Acct_ID || !this.request.Acct_Owner || !this.request.Financial_Owner || 
            !this.request.Customer_Name || !this.acctPurpose.includes(this.request.Acct_Purpose) ||
            !this.request.WBS_Code || !this.awsManagedServices.includes(this.request.Managed_Services) ||
            !this.allFieldsValid || this.errors.items.length > 0
        case 2:
          return !this.request.Internal_Vs_Saas
        case 3:
          return !this.request.Direct_Vs_Indirect_Access
        case 4:
          return !this.request.New_Workload || (this.request.New_Workload == 'Yes' && !this.request.SFDC_ID)
        case 5:
          return !this.request.New_Workload
        default:
          return false
      }

    },
    onValueConfirm(field) {
      this.validatedFields[field] = !this.validatedFields[field]
      this.editing[field] = false
    },
    onEditField(field) {
      this.editing[field] = !this.editing[field]
      this.validatedFields[field] = false
      this.$refs[field].focus()
    },
    validateStep(step) {
      if (step == 2) {
        if (this.request.Internal_Vs_Saas && this.request.Internal_Vs_Saas != 'Internal') {
          this.formStep = 3
          console.log('step updated 3')
        } else {
          this.formStep = 6
          console.log('step updated 6')
        }
      }

    }
  },
}

</script>
<style lang="scss" scoped>
.dash {
  position: relative;
  padding-bottom:100px;
  top: 25%;
}

.qa-form {
  font-size: 20px;
  .radioLabel {
      font-size: 20px;
      line-height: normal;
  }
  .v-btn-toggle{ margin:10px 0}
  .v-btn-toggle .v-btn{
    padding: 15px 38px;
    opacity: 1;
  }
  
  .btn--qa{
    font-weight: bold !important;
  }

  .v-select--width{
    width: 100%;
  }

  span{
    &.workload-desc{
      font-weight:600
    }
  }

  div {
    &.qa-desc{
      font-style: italic;
      font-size: 14px;
    }
  }
}
</style>
  